import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar/Sidebar";
import "./Dashboard.css";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <>
      <Navbar />

      <div className="admin-layout">
        <Sidebar />

        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;